import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

const useEstates = () => {
    return useContext(AuthContext);
}

export default useEstates;